import React from "react";
import PackageJson from "../../package.json";

const Footer = () => {
    return (
        <div className="card-footer d-flex justify-content-center text-muted">
            <p className="h6">
                {PackageJson.name} version: {PackageJson.version}
            </p>
        </div>
    );
};

export default Footer;
